<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="container">
    <div class="profile-header">
      <h1 class="profile-name">
        <span>{{ $t('Hey') }}</span>
        <span v-if="fullUserInfo && fullUserInfo.User && fullUserInfo.User.firstName">&nbsp;{{fullUserInfo.User.firstName}}</span>
        <span v-if="fullUserInfo && !fullUserInfo.User.lastName && !fullUserInfo.User.lastName">&nbsp;{{ $t('Stranger') }}</span>
      </h1>
      <div v-if="!this.$isAnonymous" class="stats-grid">
        <div class="stat-card">
          <div class="stat-number">{{ timelineStats.sopOpened }}</div>
          <div class="stat-label">{{ $t('SOPsOpened') }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ timelineStats.sopCompleted }}</div>
          <div class="stat-label">{{ $t('SOPsCompleted') }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ timelineStats.stepsCompleted }}</div>
          <div class="stat-label">{{ $t('StepsCompleted') }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ timelineStats.ratingsGiven }}</div>
          <div class="stat-label">{{ $t('RatingsGiven') }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ timelineStats.certificatesEarned }}</div>
          <div class="stat-label">{{ $t('CertificatesEarned') }}</div>
        </div>
      </div>
      <div v-else>
        <AnonymousProfileCard></AnonymousProfileCard>
      </div>
    </div>

    <div class="filter-container" v-if="false">
      <button class="filter-button">
        <i class="fas fa-filter"></i>
        {{ $t('Filters') }}
      </button>
      <div class="filter-dropdown">
        <div class="filter-group">
          <div class="filter-group-title">{{ $t('Position') }}</div>
          <div class="filter-option">
            <input type="checkbox" id="position1">
            <label for="position1">{{ $t('Manager') }}</label>
          </div>
          <div class="filter-option">
            <input type="checkbox" id="position2">
            <label for="position2">{{ $t('Supervisor') }}</label>
          </div>
        </div>
        <div class="filter-group">
          <div class="filter-group-title">{{ $t('Status') }}</div>
          <div class="filter-option">
            <input type="checkbox" id="status1">
            <label for="status1">{{ $t('Completed') }}</label>
          </div>
          <div class="filter-option">
            <input type="checkbox" id="status2">
            <label for="status2">{{ $t('Pending') }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="position-card" v-if="false">
      <h2 class="section-title">{{ $t('ManagerPosition') }}</h2>
      <div class="progress-container">
        <div class="progress-label">
          <span>{{ $t('Completion') }}</span>
          <span>50%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" style="width: 50%"></div>
        </div>
      </div>
      <ul class="sop-list">
        <li class="sop-item">
          <span class="sop-status complete">
            <i class="fas fa-check-circle"></i>
          </span>
          {{ $t('OpeningProcedures') }}
        </li>
        <li class="sop-item">
          <span class="sop-status pending">
            <i class="fas fa-clock"></i>
          </span>
          {{ $t('ClosingProcedures') }}
        </li>
      </ul>
    </div>

    <div class="position-card" v-if="false">
      <h2 class="section-title">{{ $t('SupervisorPosition') }}</h2>
      <div class="progress-container">
        <div class="progress-label">
          <span>{{ $t('Completion') }}</span>
          <span>100%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" style="width: 100%"></div>
        </div>
      </div>
      <ul class="sop-list">
        <li class="sop-item">
          <span class="sop-status complete">
            <i class="fas fa-check-circle"></i>
          </span>
          {{ $t('SafetyProtocol') }}
        </li>
        <li class="sop-item">
          <span class="sop-status complete">
            <i class="fas fa-check-circle"></i>
          </span>
          {{ $t('EmployeeTraining') }}
        </li>
      </ul>
    </div>

    <!-- User Journey Timeline -->
    <div v-if="!this.$isAnonymous">
      <UserJourneyTimeline></UserJourneyTimeline>
    </div>
  </div>
</template>

<script>
  import "video.js/dist/video-js.css";
  import accountsService from "@/accounts/accountsService";
  import AnonymousProfileCard from '@/components/AnonymousProfileCard.vue';
  import UserJourneyTimeline from '@/components/UserJourneyTimeline.vue';
  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

  export default {
    data() {
      return {
        fullUserInfo: accountsService.getUserObjectFromLocalStorageSafe(),
        timelineStats: {
          sopOpened: 0,
          sopCompleted: 0,
          stepsCompleted: 0,
          ratingsGiven: 0,
          certificatesEarned: 0
        }
      };
    },
    computed: {
    },
    methods: {
      async loadTimelineStats() {
        try {
          const response = await TCVelikClient.GetRelative('/api/analytics/GetUserJourneyTimeline?days=90');
          
          if (response.data && response.data.Events) {
            const events = response.data.Events;
            
            this.timelineStats = {
              sopOpened: events.filter(e => e.EventType === 'sop_opened').length,
              sopCompleted: events.filter(e => e.EventType === 'sop_completed').length,
              stepsCompleted: events.filter(e => e.EventType === 'step_completed').length,
              ratingsGiven: events.filter(e => e.EventType === 'feedback').length,
              certificatesEarned: events.filter(e => e.EventType === 'certificate_issued').length
            };
          }
        } catch (error) {
          console.error('Error loading timeline stats:', error);
        }
      }
    },
    components: {
      AnonymousProfileCard,
      UserJourneyTimeline
    },
    mounted() {
      if (!this.$isAnonymous) {
        this.loadTimelineStats();
      }
    },
    beforeDestroy() {
    },
  };
</script>

<style>
  :root {
    --primary: #6000C9;
    --primary-light: #f1d0ff;
    --error: #ef4444;
    --error-light: #fef2f2;
    --success: #22c55e;
    --success-light: #f0fdf4;
    --neutral: #64748b;
    --neutral-light: #f8fafc;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Outfit', sans-serif;
    background-color: #f5f5f5;
    color: #1e293b;
  }

  .container {
    max-width: 1000px;
    margin: 40px auto;
    padding: 40px;
  }

  .profile-header {
    background: white;
    border-radius: 20px;
    padding: 32px;
    margin-bottom: 24px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }

  .profile-name {
    font-size: 3.5em;
    font-weight: 900;
    margin: 0 0 20px 0;
    background: linear-gradient(135deg,var(--primary),#000);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1.2;
  }

  .position-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }

  .section-title {
    font-weight: 900;
    font-size: 1.25em;
    margin-bottom: 16px;
    /*color: var(--neutral);*/
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
  }

  .stat-card {
    background: var(--primary-light);
    padding: 16px;
    border-radius: 8px;
    text-align: center;
  }

  .stat-number {
    font-size: 2em;
    font-weight: 700;
    color: var(--primary);
  }

  .stat-label {
    /*color: var(--neutral);*/
    font-size: 0.9em;
  }

  .progress-container {
    margin: 16px 0;
  }

  .progress-bar {
    width: 100%;
    height: 8px;
    background: var(--neutral-light);
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }

  .progress-fill {
    height: 100%;
    background: var(--primary);
    border-radius: 4px;
    transition: width 0.8s ease-in-out;
  }

  .progress-label {
    display: flex;
    justify-content: space-between;
    color: var(--neutral);
    font-size: 0.9em;
    margin-bottom: 8px;
  }

  .sop-list {
    list-style: none;
  }

  .sop-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 8px;
    transition: all 0.3s ease;
  }

    .sop-item:hover {
      background: var(--neutral-light);
    }

  .sop-status {
    margin-right: 12px;
  }

    .sop-status.complete {
      color: var(--success);
    }

    .sop-status.pending {
      color: var(--neutral);
    }

  .filter-container {
    position: relative;
    margin-bottom: 24px;
  }

  .filter-button {
    background: white;
    border: 1px solid #e2e8f0;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .filter-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 16px;
    margin-top: 8px;
    display: none;
    z-index: 10;
    min-width: 200px;
  }

    .filter-dropdown.active {
      display: block;
    }

  .filter-group {
    margin-bottom: 16px;
  }

    .filter-group:last-child {
      margin-bottom: 0;
    }

  .filter-group-title {
    font-weight: 700;
    margin-bottom: 8px;
    color: var(--neutral);
  }

  .filter-option {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  @media (max-width: 768px) {
    .container {
      padding: 20px;
      margin: 20px auto;
    }

    .profile-header {
      padding: 24px;
    }

    .stats-grid {
      grid-template-columns: 1fr;
    }
  }

  @media print {
    .filter-container {
      display: none;
    }

    .profile-name {
      background: none;
      -webkit-text-fill-color: black;
      color: black;
    }

    .stat-card {
      background: none;
      border: 1px solid #e2e8f0;
    }
  }
</style>
